// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2780%27 height=%2710%27 viewBox=%270 0 80 10%27 preserveAspectRatio=%27none%27%3E%3Cpath d=%27M0 5 Q5 0 10 5 T20 5 T30 5 T40 5 T50 5 T60 5 T70 5 T80 5%27 fill=%27none%27 stroke=%27rgba%28226,232,244,0.7%29%27 stroke-width=%271.4%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Space-encounter idle animation — a full-page, narrative ambient effect
 * rotated in by the IdleAnimationDirector alongside the toy parade and the
 * shooting stars.
 *
 * Choreography (driven phase-by-phase from TypeScript):
 *   1. A human shuttle descends and fades in, coming to rest at a fixed
 *      lower-center spot of the viewport.
 *   2. A tethered astronaut trails out and settles BEHIND the shuttle.
 *   3. A beat passes.
 *   4. An alien fleet (a mothership plus escort cruisers) slides in from the
 *      right and approaches in formation.
 *   5. The shuttle bolts left to escape ALONE — the tether snaps and the
 *      astronaut is left stranded in place while the fleet recoils.
 *
 * Every actor is a flat, single-color silhouette (fill: currentColor). All
 * motion is CSS-keyframe driven; the director removes the whole page stage
 * (and these actors) when the pass ends, so nothing lingers over content.
 *
 * The fallback fixed, full-viewport \`.idle-stage--page\` layer is defined in
 * shooting-star-animation.css (fixed, inset 0, z-index -1, pointer-events none).
 * The shooting stars now use their own dedicated \`.idle-stage--fullpage\` layer.
 */

/* -------------------------------------------------------------------------
 * Calendar-anchored stage
 *
 * When the director can locate the calendar it mounts the stage as an absolute
 * overlay sized to the calendar's box (see resolveStage in the director) instead
 * of the shared fixed, viewport-sized layer. Positioned above the Cosmos
 * backdrop but below the UI panels (which sit at z-index 40+), so the encounter
 * reads as a layer between the panels and the background, clipped to the
 * calendar rather than the page edges.
 * ------------------------------------------------------------------------- */
.idle-stage--calendar {
  position: absolute;
  inset: auto;
  z-index: 1;
  /* A short band sitting just below the calendar. Actors descend into it from
     above and the alien slides across from off-stage, so motion must not be
     clipped to the band's box. */
  overflow: visible;
  pointer-events: none;
}

/* -------------------------------------------------------------------------
 * Shared actor anchoring
 *
 * Actors are anchored to a fixed lower-center rest spot. \`left: 50%\` plus a
 * translate keeps them horizontally centered; \`bottom\` lifts them above the
 * footer. Per-phase keyframes then translate/scale relative to that anchor.
 * ------------------------------------------------------------------------- */
.space-actor {
  position: absolute;
  /* Anchored within the band that sits just below the calendar. \`top\` places the
     actors near the band's vertical center; per-actor \`left\`/\`right\` pin them to
     the calendar's edges. */
  left: 6%;
  top: 40px;
  pointer-events: none;
  will-change: transform, opacity;
}

.space-actor svg {
  display: block;
}

/* --- Human shuttle --------------------------------------------------------- */
.space-shuttle {
  width: 84px;
  color: rgb(198, 214, 238);
  opacity: 0;
  /* Rest anchor: near the LEFT edge of the calendar. */
  transform: translate(0, 0);
}

.space-shuttle--descend {
  animation: space-shuttle-descend 1600ms ease-out forwards;
}

.space-shuttle--flee {
  animation: space-shuttle-flee 1200ms cubic-bezier(0.5, 0, 0.75, 0) forwards;
}

/* --- Tethered astronaut ---------------------------------------------------- */
.space-astronaut {
  width: 18px;
  color: rgb(226, 232, 244);
  opacity: 0;
  /* Starts tucked at the shuttle's REAR (its right side, since the ship faces
     left) then trails further right during the tether-out phase. */
  transform: translate(86px, -4px);
}

.space-astronaut--out {
  animation: space-astronaut-out 900ms ease-out forwards;
}

/* NOTE: the astronaut is intentionally LEFT BEHIND when the shuttle flees, so it
   has no flee/trail state — it simply holds its rest position from --out until
   the strand fade-out below gently removes it after a lingering beat. */
.space-astronaut--strand {
  /* Holds the astronaut's rest transform and just fades it away. */
  animation: space-astronaut-strand 900ms ease-in forwards;
}

/* --- Surprise mark ----------------------------------------------------------
 * A little "!" that pops just above the stranded astronaut once the shuttle
 * bolts, selling the surprise. Anchored like the actors (left/top) and offset to
 * sit by the astronaut's helmet (astronaut rests near +118px, top 40px). */
.space-surprise {
  position: absolute;
  left: 6%;
  top: 40px;
  font-weight: 800;
  font-size: 20px;
  line-height: 1;
  color: rgb(255, 214, 120);
  text-shadow: 0 0 6px rgba(255, 190, 90, 0.7);
  opacity: 0;
  pointer-events: none;
  will-change: transform, opacity;
  /* Just above-right of the astronaut's helmet. */
  transform: translate(132px, -22px) scale(0.4);
  transform-origin: center bottom;
}

.space-surprise--pop {
  animation: space-surprise-pop 900ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.space-surprise--fade {
  /* Fades the mark out alongside the stranded astronaut after the linger beat. */
  animation: space-surprise-fade 900ms ease-in forwards;
}

/* --- Tether line -----------------------------------------------------------
 * A short squiggly cable bridging the shuttle's rear and the trailing astronaut.
 * The shuttle rest box ends at center+60px and the astronaut rests at center+70px
 * (24px wide), so the tether spans roughly center+56 -> center+74 and overlaps
 * both ends slightly so it visibly CONNECTS to each. The wave shape is an inline
 * SVG background so it reads as a loose, dangling cable. */
.space-tether {
  position: absolute;
  left: 6%;
  top: 40px;
  height: 8px;
  width: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* One continuous multi-hump wave drawn as a single path stretched to fill the
     element (no background tiling), so there are no seams between repetitions. */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transform-origin: left center;
  /* Anchored at the shuttle's REAR (right edge, ~80px) and lifted to mid-body. */
  transform: translate(80px, 4px) scaleX(0);
  opacity: 0;
  pointer-events: none;
}

.space-tether--out {
  animation: space-tether-out 900ms ease-out forwards;
}

.space-tether--snap {
  /* The shuttle tears free: the tether's shuttle-end snaps back and the cable
     goes limp, staying put by the stranded astronaut rather than trailing off. */
  animation: space-tether-snap 900ms cubic-bezier(0.2, 0.8, 0.3, 1) forwards;
}

/* --- Alien fleet ------------------------------------------------------------
 * A small fleet enters from off-stage to the RIGHT: one full-size mothership
 * plus a few leaner escort cruisers arranged in a loose formation. All share
 * the right-boundary anchoring; per-ship modifiers offset their rest spot and
 * stagger their approach so they read as a fleet rather than one craft. */
.space-alien {
  color: rgb(150, 224, 180);
  opacity: 0;
  /* Right-boundary anchor: override the shared left-edge .space-actor placement.
     Pulled further inside the calendar (was 3%) so the fleet stops closer to the
     human shuttle rather than hugging the right edge. */
  left: auto;
  right: 18%;
  /* Enters off-stage to the RIGHT of its rest spot. A large fixed slide distance
     keeps the entry readable across calendar sizes (translate % would reference
     the small actor box, not the stage). */
  transform: translate(900px, -18px);
}

/* Flagship at full size, leading the formation. */
.space-alien--mothership {
  width: 72px;
  --fleet-x: 0px;
  --fleet-y: -14px;
  --fleet-delay: 0ms;
}

/* Leaner escort cruisers, offset above/below and behind the mothership. */
.space-alien--escort-1 {
  width: 44px;
  --fleet-x: 58px;
  --fleet-y: -40px;
  --fleet-delay: 180ms;
}

.space-alien--escort-2 {
  width: 40px;
  --fleet-x: 74px;
  --fleet-y: 12px;
  --fleet-delay: 320ms;
}

.space-alien--escort-3 {
  width: 34px;
  --fleet-x: 120px;
  --fleet-y: -8px;
  --fleet-delay: 460ms;
}

.space-alien--approach {
  animation: space-alien-approach 2400ms ease-out var(--fleet-delay, 0ms) forwards;
}

.space-alien--recoil {
  animation: space-alien-recoil 1200ms ease-in forwards;
}

/* -------------------------------------------------------------------------
 * Keyframes
 * ------------------------------------------------------------------------- */

/* Shuttle drops in from above and fades up to the rest spot. */
@keyframes space-shuttle-descend {
  0% {
    opacity: 0;
    transform: translate(0, -90px);
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

/* Shuttle bolts hard to the left, banking slightly, and exits. */
@keyframes space-shuttle-flee {
  0% {
    opacity: 1;
    transform: translate(0, 0) rotate(0deg);
  }
  100% {
    opacity: 0;
    transform: translate(-480px, -30px) rotate(-12deg);
  }
}

/* Astronaut trails out to rest just behind (to the right of) the shuttle. */
@keyframes space-astronaut-out {
  0% {
    opacity: 0;
    transform: translate(86px, -4px);
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translate(118px, -4px);
  }
}

/* Tether extends from the shuttle rear out to the trailing astronaut. */
@keyframes space-tether-out {
  0% {
    opacity: 0;
    transform: translate(80px, 4px) scaleX(0);
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translate(80px, 4px) scaleX(1);
  }
}

/* Tether snaps free of the fleeing shuttle and goes limp beside the stranded
 * astronaut. It stays anchored near the astronaut's rest spot (no trailing off);
 * the shuttle-end recoils slightly and the cable slackens. */
@keyframes space-tether-snap {
  0% {
    opacity: 1;
    transform: translate(80px, 4px) scaleX(1);
  }
  35% {
    /* Shuttle-end whips back toward the astronaut as the line parts. */
    transform: translate(96px, 6px) scaleX(0.55) rotate(-6deg);
  }
  100% {
    /* Comes to rest as a short slack cable dangling by the astronaut. */
    opacity: 0.85;
    transform: translate(100px, 8px) scaleX(0.5) rotate(4deg);
  }
}

/* Fleet ship slides in from the right edge and eases up to its formation spot.
 * Per-ship --fleet-x/--fleet-y offsets spread the ships into a loose formation. */
@keyframes space-alien-approach {
  0% {
    opacity: 0;
    transform: translate(900px, -18px);
  }
  25% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translate(var(--fleet-x, 0px), var(--fleet-y, -14px));
  }
}

/* Fleet flinches back (to the right) as the shuttle bolts, holding formation. */
@keyframes space-alien-recoil {
  0% {
    opacity: 1;
    transform: translate(var(--fleet-x, 0px), var(--fleet-y, -14px));
  }
  100% {
    opacity: 0;
    transform: translate(calc(var(--fleet-x, 0px) + 80px), calc(var(--fleet-y, -14px) - 16px));
  }
}

/* Astronaut, left stranded, gently fades away after a lingering beat. Holds its
 * rest transform so it doesn't drift while disappearing. */
@keyframes space-astronaut-strand {
  0% {
    opacity: 1;
    transform: translate(118px, -4px);
  }
  100% {
    opacity: 0;
    transform: translate(118px, -4px);
  }
}

/* Surprise "!" pops in above the stranded astronaut with a springy overshoot
 * and a tiny wobble, then holds. */
@keyframes space-surprise-pop {
  0% {
    opacity: 0;
    transform: translate(132px, -22px) scale(0.4);
  }
  45% {
    opacity: 1;
    transform: translate(132px, -30px) scale(1.25);
  }
  65% {
    transform: translate(132px, -28px) scale(0.95) rotate(-8deg);
  }
  100% {
    opacity: 1;
    transform: translate(132px, -30px) scale(1.05) rotate(0deg);
  }
}

/* Surprise "!" fades out in place alongside the stranded astronaut. */
@keyframes space-surprise-fade {
  0% {
    opacity: 1;
    transform: translate(132px, -30px) scale(1.05);
  }
  100% {
    opacity: 0;
    transform: translate(132px, -34px) scale(0.9);
  }
}

/* -------------------------------------------------------------------------
 * Reduced motion: never play this animation's motion. The director already
 * skips idle animations under reduced-motion, but guard the stage/actors too.
 * ------------------------------------------------------------------------- */
@media (prefers-reduced-motion: reduce) {
  .space-actor,
  .space-tether,
  .space-surprise {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/idle-animation/space-encounter-animation.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;EAsBE;;AAEF;;;;;;;;;8EAS8E;AAC9E;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV;;iCAE+B;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;8EAM8E;AAC9E;EACE,kBAAkB;EAClB;;4BAE0B;EAC1B,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,2EAA2E;AAC7E;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV;mEACiE;EACjE,gCAAgC;AAClC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;wEAEwE;AACxE;EACE,iEAAiE;EACjE,wDAAwD;AAC1D;;AAEA;;;2EAG2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,4CAA4C;EAC5C,UAAU;EACV,oBAAoB;EACpB,+BAA+B;EAC/B,gDAAgD;EAChD,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,+EAA+E;EAC/E,qDAAqD;AACvD;;AAEA;;;;;2DAK2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,yDAAqU;EACrU;iFAC+E;EAC/E,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,+EAA+E;EAC/E,yCAAyC;EACzC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;iFAC+E;EAC/E,0EAA0E;AAC5E;;AAEA;;;;0EAI0E;AAC1E;EACE,yBAAyB;EACzB,UAAU;EACV;;wDAEsD;EACtD,UAAU;EACV,UAAU;EACV;;2CAEyC;EACzC,kCAAkC;AACpC;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;8EAE8E;;AAE9E,+DAA+D;AAC/D;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;AACF;;AAEA,4EAA4E;AAC5E;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;;6DAE6D;AAC7D;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,mEAAmE;IACnE,0DAA0D;EAC5D;EACA;IACE,oEAAoE;IACpE,aAAa;IACb,yDAAyD;EAC3D;AACF;;AAEA;kFACkF;AAClF;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,gEAAgE;EAClE;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,UAAU;IACV,gEAAgE;EAClE;EACA;IACE,UAAU;IACV,0FAA0F;EAC5F;AACF;;AAEA;2DAC2D;AAC3D;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;mCACmC;AACnC;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,8CAA8C;EAChD;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,UAAU;IACV,2DAA2D;EAC7D;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,UAAU;IACV,8CAA8C;EAChD;EACA;IACE,UAAU;IACV,6CAA6C;EAC/C;AACF;;AAEA;;;8EAG8E;AAC9E;EACE;;;IAGE,aAAa;EACf;AACF","sourcesContent":["/*\r\n * Space-encounter idle animation — a full-page, narrative ambient effect\r\n * rotated in by the IdleAnimationDirector alongside the toy parade and the\r\n * shooting stars.\r\n *\r\n * Choreography (driven phase-by-phase from TypeScript):\r\n *   1. A human shuttle descends and fades in, coming to rest at a fixed\r\n *      lower-center spot of the viewport.\r\n *   2. A tethered astronaut trails out and settles BEHIND the shuttle.\r\n *   3. A beat passes.\r\n *   4. An alien fleet (a mothership plus escort cruisers) slides in from the\r\n *      right and approaches in formation.\r\n *   5. The shuttle bolts left to escape ALONE — the tether snaps and the\r\n *      astronaut is left stranded in place while the fleet recoils.\r\n *\r\n * Every actor is a flat, single-color silhouette (fill: currentColor). All\r\n * motion is CSS-keyframe driven; the director removes the whole page stage\r\n * (and these actors) when the pass ends, so nothing lingers over content.\r\n *\r\n * The fallback fixed, full-viewport `.idle-stage--page` layer is defined in\r\n * shooting-star-animation.css (fixed, inset 0, z-index -1, pointer-events none).\r\n * The shooting stars now use their own dedicated `.idle-stage--fullpage` layer.\r\n */\r\n\r\n/* -------------------------------------------------------------------------\r\n * Calendar-anchored stage\r\n *\r\n * When the director can locate the calendar it mounts the stage as an absolute\r\n * overlay sized to the calendar's box (see resolveStage in the director) instead\r\n * of the shared fixed, viewport-sized layer. Positioned above the Cosmos\r\n * backdrop but below the UI panels (which sit at z-index 40+), so the encounter\r\n * reads as a layer between the panels and the background, clipped to the\r\n * calendar rather than the page edges.\r\n * ------------------------------------------------------------------------- */\r\n.idle-stage--calendar {\r\n  position: absolute;\r\n  inset: auto;\r\n  z-index: 1;\r\n  /* A short band sitting just below the calendar. Actors descend into it from\r\n     above and the alien slides across from off-stage, so motion must not be\r\n     clipped to the band's box. */\r\n  overflow: visible;\r\n  pointer-events: none;\r\n}\r\n\r\n/* -------------------------------------------------------------------------\r\n * Shared actor anchoring\r\n *\r\n * Actors are anchored to a fixed lower-center rest spot. `left: 50%` plus a\r\n * translate keeps them horizontally centered; `bottom` lifts them above the\r\n * footer. Per-phase keyframes then translate/scale relative to that anchor.\r\n * ------------------------------------------------------------------------- */\r\n.space-actor {\r\n  position: absolute;\r\n  /* Anchored within the band that sits just below the calendar. `top` places the\r\n     actors near the band's vertical center; per-actor `left`/`right` pin them to\r\n     the calendar's edges. */\r\n  left: 6%;\r\n  top: 40px;\r\n  pointer-events: none;\r\n  will-change: transform, opacity;\r\n}\r\n\r\n.space-actor svg {\r\n  display: block;\r\n}\r\n\r\n/* --- Human shuttle --------------------------------------------------------- */\r\n.space-shuttle {\r\n  width: 84px;\r\n  color: rgb(198, 214, 238);\r\n  opacity: 0;\r\n  /* Rest anchor: near the LEFT edge of the calendar. */\r\n  transform: translate(0, 0);\r\n}\r\n\r\n.space-shuttle--descend {\r\n  animation: space-shuttle-descend 1600ms ease-out forwards;\r\n}\r\n\r\n.space-shuttle--flee {\r\n  animation: space-shuttle-flee 1200ms cubic-bezier(0.5, 0, 0.75, 0) forwards;\r\n}\r\n\r\n/* --- Tethered astronaut ---------------------------------------------------- */\r\n.space-astronaut {\r\n  width: 18px;\r\n  color: rgb(226, 232, 244);\r\n  opacity: 0;\r\n  /* Starts tucked at the shuttle's REAR (its right side, since the ship faces\r\n     left) then trails further right during the tether-out phase. */\r\n  transform: translate(86px, -4px);\r\n}\r\n\r\n.space-astronaut--out {\r\n  animation: space-astronaut-out 900ms ease-out forwards;\r\n}\r\n\r\n/* NOTE: the astronaut is intentionally LEFT BEHIND when the shuttle flees, so it\r\n   has no flee/trail state — it simply holds its rest position from --out until\r\n   the strand fade-out below gently removes it after a lingering beat. */\r\n.space-astronaut--strand {\r\n  /* Holds the astronaut's rest transform and just fades it away. */\r\n  animation: space-astronaut-strand 900ms ease-in forwards;\r\n}\r\n\r\n/* --- Surprise mark ----------------------------------------------------------\r\n * A little \"!\" that pops just above the stranded astronaut once the shuttle\r\n * bolts, selling the surprise. Anchored like the actors (left/top) and offset to\r\n * sit by the astronaut's helmet (astronaut rests near +118px, top 40px). */\r\n.space-surprise {\r\n  position: absolute;\r\n  left: 6%;\r\n  top: 40px;\r\n  font-weight: 800;\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  color: rgb(255, 214, 120);\r\n  text-shadow: 0 0 6px rgba(255, 190, 90, 0.7);\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  will-change: transform, opacity;\r\n  /* Just above-right of the astronaut's helmet. */\r\n  transform: translate(132px, -22px) scale(0.4);\r\n  transform-origin: center bottom;\r\n}\r\n\r\n.space-surprise--pop {\r\n  animation: space-surprise-pop 900ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\r\n}\r\n\r\n.space-surprise--fade {\r\n  /* Fades the mark out alongside the stranded astronaut after the linger beat. */\r\n  animation: space-surprise-fade 900ms ease-in forwards;\r\n}\r\n\r\n/* --- Tether line -----------------------------------------------------------\r\n * A short squiggly cable bridging the shuttle's rear and the trailing astronaut.\r\n * The shuttle rest box ends at center+60px and the astronaut rests at center+70px\r\n * (24px wide), so the tether spans roughly center+56 -> center+74 and overlaps\r\n * both ends slightly so it visibly CONNECTS to each. The wave shape is an inline\r\n * SVG background so it reads as a loose, dangling cable. */\r\n.space-tether {\r\n  position: absolute;\r\n  left: 6%;\r\n  top: 40px;\r\n  height: 8px;\r\n  width: 50px;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='10' viewBox='0 0 80 10' preserveAspectRatio='none'%3E%3Cpath d='M0 5 Q5 0 10 5 T20 5 T30 5 T40 5 T50 5 T60 5 T70 5 T80 5' fill='none' stroke='rgba(226,232,244,0.7)' stroke-width='1.4' stroke-linecap='round'/%3E%3C/svg%3E\");\r\n  /* One continuous multi-hump wave drawn as a single path stretched to fill the\r\n     element (no background tiling), so there are no seams between repetitions. */\r\n  background-repeat: no-repeat;\r\n  background-size: 100% 100%;\r\n  transform-origin: left center;\r\n  /* Anchored at the shuttle's REAR (right edge, ~80px) and lifted to mid-body. */\r\n  transform: translate(80px, 4px) scaleX(0);\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.space-tether--out {\r\n  animation: space-tether-out 900ms ease-out forwards;\r\n}\r\n\r\n.space-tether--snap {\r\n  /* The shuttle tears free: the tether's shuttle-end snaps back and the cable\r\n     goes limp, staying put by the stranded astronaut rather than trailing off. */\r\n  animation: space-tether-snap 900ms cubic-bezier(0.2, 0.8, 0.3, 1) forwards;\r\n}\r\n\r\n/* --- Alien fleet ------------------------------------------------------------\r\n * A small fleet enters from off-stage to the RIGHT: one full-size mothership\r\n * plus a few leaner escort cruisers arranged in a loose formation. All share\r\n * the right-boundary anchoring; per-ship modifiers offset their rest spot and\r\n * stagger their approach so they read as a fleet rather than one craft. */\r\n.space-alien {\r\n  color: rgb(150, 224, 180);\r\n  opacity: 0;\r\n  /* Right-boundary anchor: override the shared left-edge .space-actor placement.\r\n     Pulled further inside the calendar (was 3%) so the fleet stops closer to the\r\n     human shuttle rather than hugging the right edge. */\r\n  left: auto;\r\n  right: 18%;\r\n  /* Enters off-stage to the RIGHT of its rest spot. A large fixed slide distance\r\n     keeps the entry readable across calendar sizes (translate % would reference\r\n     the small actor box, not the stage). */\r\n  transform: translate(900px, -18px);\r\n}\r\n\r\n/* Flagship at full size, leading the formation. */\r\n.space-alien--mothership {\r\n  width: 72px;\r\n  --fleet-x: 0px;\r\n  --fleet-y: -14px;\r\n  --fleet-delay: 0ms;\r\n}\r\n\r\n/* Leaner escort cruisers, offset above/below and behind the mothership. */\r\n.space-alien--escort-1 {\r\n  width: 44px;\r\n  --fleet-x: 58px;\r\n  --fleet-y: -40px;\r\n  --fleet-delay: 180ms;\r\n}\r\n\r\n.space-alien--escort-2 {\r\n  width: 40px;\r\n  --fleet-x: 74px;\r\n  --fleet-y: 12px;\r\n  --fleet-delay: 320ms;\r\n}\r\n\r\n.space-alien--escort-3 {\r\n  width: 34px;\r\n  --fleet-x: 120px;\r\n  --fleet-y: -8px;\r\n  --fleet-delay: 460ms;\r\n}\r\n\r\n.space-alien--approach {\r\n  animation: space-alien-approach 2400ms ease-out var(--fleet-delay, 0ms) forwards;\r\n}\r\n\r\n.space-alien--recoil {\r\n  animation: space-alien-recoil 1200ms ease-in forwards;\r\n}\r\n\r\n/* -------------------------------------------------------------------------\r\n * Keyframes\r\n * ------------------------------------------------------------------------- */\r\n\r\n/* Shuttle drops in from above and fades up to the rest spot. */\r\n@keyframes space-shuttle-descend {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(0, -90px);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translate(0, 0);\r\n  }\r\n}\r\n\r\n/* Shuttle bolts hard to the left, banking slightly, and exits. */\r\n@keyframes space-shuttle-flee {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translate(0, 0) rotate(0deg);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(-480px, -30px) rotate(-12deg);\r\n  }\r\n}\r\n\r\n/* Astronaut trails out to rest just behind (to the right of) the shuttle. */\r\n@keyframes space-astronaut-out {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(86px, -4px);\r\n  }\r\n  40% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translate(118px, -4px);\r\n  }\r\n}\r\n\r\n/* Tether extends from the shuttle rear out to the trailing astronaut. */\r\n@keyframes space-tether-out {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(80px, 4px) scaleX(0);\r\n  }\r\n  40% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translate(80px, 4px) scaleX(1);\r\n  }\r\n}\r\n\r\n/* Tether snaps free of the fleeing shuttle and goes limp beside the stranded\r\n * astronaut. It stays anchored near the astronaut's rest spot (no trailing off);\r\n * the shuttle-end recoils slightly and the cable slackens. */\r\n@keyframes space-tether-snap {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translate(80px, 4px) scaleX(1);\r\n  }\r\n  35% {\r\n    /* Shuttle-end whips back toward the astronaut as the line parts. */\r\n    transform: translate(96px, 6px) scaleX(0.55) rotate(-6deg);\r\n  }\r\n  100% {\r\n    /* Comes to rest as a short slack cable dangling by the astronaut. */\r\n    opacity: 0.85;\r\n    transform: translate(100px, 8px) scaleX(0.5) rotate(4deg);\r\n  }\r\n}\r\n\r\n/* Fleet ship slides in from the right edge and eases up to its formation spot.\r\n * Per-ship --fleet-x/--fleet-y offsets spread the ships into a loose formation. */\r\n@keyframes space-alien-approach {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(900px, -18px);\r\n  }\r\n  25% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translate(var(--fleet-x, 0px), var(--fleet-y, -14px));\r\n  }\r\n}\r\n\r\n/* Fleet flinches back (to the right) as the shuttle bolts, holding formation. */\r\n@keyframes space-alien-recoil {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translate(var(--fleet-x, 0px), var(--fleet-y, -14px));\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(calc(var(--fleet-x, 0px) + 80px), calc(var(--fleet-y, -14px) - 16px));\r\n  }\r\n}\r\n\r\n/* Astronaut, left stranded, gently fades away after a lingering beat. Holds its\r\n * rest transform so it doesn't drift while disappearing. */\r\n@keyframes space-astronaut-strand {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translate(118px, -4px);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(118px, -4px);\r\n  }\r\n}\r\n\r\n/* Surprise \"!\" pops in above the stranded astronaut with a springy overshoot\r\n * and a tiny wobble, then holds. */\r\n@keyframes space-surprise-pop {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(132px, -22px) scale(0.4);\r\n  }\r\n  45% {\r\n    opacity: 1;\r\n    transform: translate(132px, -30px) scale(1.25);\r\n  }\r\n  65% {\r\n    transform: translate(132px, -28px) scale(0.95) rotate(-8deg);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translate(132px, -30px) scale(1.05) rotate(0deg);\r\n  }\r\n}\r\n\r\n/* Surprise \"!\" fades out in place alongside the stranded astronaut. */\r\n@keyframes space-surprise-fade {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translate(132px, -30px) scale(1.05);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(132px, -34px) scale(0.9);\r\n  }\r\n}\r\n\r\n/* -------------------------------------------------------------------------\r\n * Reduced motion: never play this animation's motion. The director already\r\n * skips idle animations under reduced-motion, but guard the stage/actors too.\r\n * ------------------------------------------------------------------------- */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .space-actor,\r\n  .space-tether,\r\n  .space-surprise {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
